var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 5.33333C1.33325 5.33333 4.31802 2 7.99992 2C11.6818 2 14.6666 5.33333 14.6666 5.33333",
    stroke: "#78787D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3626 8.69675C14.5653 8.98095 14.6666 9.12308 14.6666 9.33341C14.6666 9.54375 14.5653 9.68588 14.3626 9.97008C13.4519 11.2471 11.1261 14.0001 7.99992 14.0001C4.87377 14.0001 2.54799 11.2471 1.63728 9.97008C1.43459 9.68588 1.33325 9.54375 1.33325 9.33341C1.33325 9.12308 1.43459 8.98095 1.63728 8.69675C2.54799 7.41968 4.87377 4.66675 7.99992 4.66675C11.1261 4.66675 13.4519 7.41968 14.3626 8.69675Z",
    stroke: "#78787D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.33325C10 8.22865 9.1046 7.33325 8 7.33325C6.8954 7.33325 6 8.22865 6 9.33325C6 10.4379 6.8954 11.3333 8 11.3333C9.1046 11.3333 10 10.4379 10 9.33325Z",
    stroke: "#78787D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1632b825b3e96b1ba5cfc90921333036.svg";
export { ForwardRef as ReactComponent };